<template>
  <div class="wrapper wover">
  <div class="wrapp reports-body" id="mainpage">
    <div class="row col-12 pageHeader">
      <span class="col-12">Buscar Chassi</span>
    </div>
    <div class="col-12 pageFilter">
      <label
        style="padding-top: 10px;"
        for="searchChassi"
      >
        Chassi
      </label>
      <b-form-input
        id="searchChassi"
        type="text"
        v-model="searchChassi"
        required
      />
      <button
        class="search-chassi-button"
        @click="obtemDadosGic"
      >
        Buscar
      </button>
    </div>
    <div class="row pageData">
      <div class="card col-12">
        <div class="col-12" style="display: flex; padding: 0px;">
          <div
            v-if="loadingChassis"
            class="text-center"
            style="padding-top: 20px;"
          >
            <b-spinner
              variant="primary"
              type="grow"
              label="Spinning"
            ></b-spinner>
          </div>
          <div v-else class="col-12" style="padding: 0px;">
            <b-table
              :items="itemsChassi"
              :fields="fields"
              id="tabchassi"
              class="col-12"
            >
              <template v-slot:cell(valor)="row">
                <div v-if="row.item.realce" class="row-realce"> {{ row.item.valor }}
                </div>
                <div v-else class="row-norealce"> {{ row.item.valor }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';

const url = 'https://api.bi-assobens.com.br/v1';
// const url = 'http://localhost:3000/v1';

export default {
  name: 'ChassiEspecifico',
  components: {},
  data: () => ({
    user: null,
    userAuth: null,
    segmento: null,
    areaOper: null,
    areaOperGic: [],
    segmentoList: [],
    userSegments: [],
    areaOperList: [],
    userAreaOper: [],
    userMarcas: [],
    segmentoOptions: [],
    areaOperOptions: [],
    gicDados: {},
    loadingChassis: false,
    searchChassi: '',
    itemsChassi: [],
    fields: [
      { key: 'chave', label: '', class:'text-right tabvalor' },
      { key: 'valor', label: '' },
    ],
  }),
  watch: {},
  computed: {},
  methods: {
    async getUser() {
      try {
        const { data } = await axios.get(`${url}/user/${this.userAuth.id}`, {});
        this.user = data;
      } catch (error) {
        this.$swal('Falhou!', `${error.response.data.message}`, 'error');
      }
    },
    formatDateBR(a){
      return a.substr(8,2)+'/'+a.substr(5,2)+'/'+a.substr(0,4);
    },
    async getUserSegments() {
      // carrega segmentos do usuario
      const { data } = await axios.get(`${url}/segments/${this.userAuth.id}`);
      this.userSegments = data;
    },
    async carregaSegmentos() {
      try {
        // carrega todos os segmentos
        const { data } = await axios.get(`${url}/dados/segmentos`);
        this.segmentoList = data;

        await this.getUserSegments();

        // monta lista de segmentos
        // se usuario = master, nao tem restricao de segmento
        this.segmentoOptions = [];
        if (!(this.userAuth.type === 'master')) {
          for (let i = 0; i < this.userSegments.length; i += 1) {
            this.segmentoOptions.push({
              value: this.userSegments[i].segmentId,
              // value: this.segmentoList[i].descricao,
              text: await this.getSegmentName(this.userSegments[i].segmentId),
            });
          }          
        } else {
          for (let i = 0; i < this.segmentoList.length; i++) {
            this.segmentoOptions.push({
              value: this.segmentoList[i].segmento,
              // value: this.segmentoList[i].descricao,
              text: this.segmentoList[i].descricao,
            });
          }
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async carregaAreas() {
      try {
        const { data } = await axios.get(`${url}/dados/areas`);
        this.areaOperList = data;
        // se for dealer, tem restricao de area
        this.areaOperOptions = [];
        if (this.userAuth.type === 'dealer') {
          for (let i = 0; i < this.user.dealers.length; i += 1) {
            for (let j = 0; j < this.areaOperList.length; j += 1) {
              if (this.user.dealers[i].operational_area === this.areaOperList[j].areaOperacional) {
                this.areaOperOptions.push(this.areaOperList[j].areaOperacional);
              }
            }
          }
        } else {
          for (let i = 0; i < this.areaOperList.length; i++) {
            this.areaOperOptions.push(this.areaOperList[i].areaOperacional);
          }
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
    },
    async obtemDadosGic() {
      if (!this.searchChassi) {
        return;
      }
      this.loadingChassis = true;
      this.gicDados = {};
      try {
        const { data } = await axios.get(`${url}/dados/gic-chassis/${this.searchChassi}`,{
          params: {
            areaOper: this.areaOperOptions,
          }
        });
        this.gicDados.chassis = data.gicChassi;
        if (this.gicDados.chassis.length > 0) {
          this.itemsChassi = [];
          let i = 0;
          const isJuridica = this.gicDados.chassis[0]['C_TIPOCNPJPROPRIETARIO'] === 'JURIDICA';
          for (var property in this.gicDados.chassis[0]){
            const prop = property;
            const formato = this.formatKey(prop);
            const valor = this.formatValor(prop, isJuridica, this.gicDados.chassis[0][prop]);
            this.itemsChassi.push({
              chave: formato.valor,
              valor: valor ? valor : '.',
              realce: formato.realce,
            });
            i = i + 1;
          }
        } else {
          this.$swal('Não encontrado', 'Número de Chassi não encontrado', 'error');
        }
      } catch (error) {
        window.console.log('Falhou!', error);
      }
      this.loadingChassis = false;
    },
    formatKey(key) {
      let ret = '';
      let realce = false;
      switch (key) {
        case 'CHASSI':
          ret = 'Chassi';
          realce = true;
          break;
        case 'MODELO':
          ret = 'Modelo';
          realce = true;
          break;
        case 'MARCA_COMPLETA':
          ret = 'Marca';
          realce = true;
          break;
        case 'DATA_COMPLETA':
          ret = 'Data Emplacamento';
          realce = true;
          break;
        case 'SEGMENTO':
          ret = 'Segmento';
          realce = true;
          break;
        case 'SUBSEGMENTO':
          ret = 'SubSegmento';
          realce = true;
          break;
        case 'PLACA':
          ret = 'Placa';
          realce = true;
          break;
        case 'RAZAO_SOCIAL':
          ret = 'Concessionário';
          realce = true;
          break;
        case 'MUNICIPIO':
          ret = 'Município';
          realce = true;
          break;
        case 'ESTADO':
          ret = 'Estado';
          realce = true;
          break;
        case 'ANOFABRICACAO':
          ret = 'Ano Fabricação';
          realce = true;
          break;
        case 'ANOMODELO':
          ret = 'Ano Modelo';
          realce = true;
          break;
        case 'DEALER_AOP':
          ret = 'Desc. Área Operacional';
          realce = true;
          break;
        case 'AREA_OPERACIONAL':
          ret = 'Área Operacional';
          realce = true;
          break;
        case 'C_CPFCNPJPROPRIETARIO':
          ret = 'CPF ou CNPJ do Proprietário';
          break;
        case 'C_TIPOCNPJPROPRIETARIO':
          ret = 'Tipo de Pessoa';
          break;
        case 'C_NOMEPROPRIETARIO':
          ret = 'Nome do Proprietário';
          break;
        case 'C_NO_LOGR':
          ret = 'Endereço';
          break;
        case 'C_NU_LOGR':
          ret = 'Número';
          break;
        case 'C_NO_COMPL':
          ret = 'Complemento';
          break;
        case 'C_NO_BAIRRO':
          ret = 'Bairro';
          break;
        case 'C_NO_CIDADE':
          ret = 'Cidade';
          break;
        case 'C_SG_ESTADO':
          ret = 'Estado';
          break;
        case 'C_NU_CEP':
          ret = 'CEP';
          break;
        case 'C_DDD1':
          ret = 'DDD1';
          break;
        case 'C_TELEFONE1':
          ret = 'Telefone1';
          break;
        case 'C_DDD2':
          ret = 'DDD2';
          break;
        case 'C_TELEFONE2':
          ret = 'Telefone2';
          break;
        case 'C_DDD3':
          ret = 'DDD3';
          break;
        case 'C_TELEFONE3':
          ret = 'Telefone3';
          break;
        case 'C_DDD_CELULAR1':
          ret = 'DDD Celular1';
          break;
        case 'C_CELULAR1':
          ret = 'Celular1';
          break;
        case 'C_DDD_CELULAR2':
          ret = 'DDD Celular2';
          break;
        case 'C_CELULAR2':
          ret = 'Celular 2';
          break;
        case 'C_EMAIL':
          ret = 'E-mail';
          break;
        default:
          break;
      }
      return { valor: ret, realce };
    },
    formatValor(key, isJuridica, valor) {
      if (key === 'DATA_COMPLETA') {
        return this.formatDateBR(valor);
      }
      if (isJuridica) {
        return (valor);
      }
      switch (key) {
        case 'C_CPFCNPJPROPRIETARIO':
        case 'C_NOMEPROPRIETARIO':
        case 'C_NO_LOGR':
        case 'C_NU_LOGR':
        case 'C_NO_COMPL':
        case 'C_NO_BAIRRO':
        case 'C_NO_CIDADE':
        case 'C_SG_ESTADO':
        case 'C_NU_CEP':
        case 'C_DDD1':
        case 'C_TELEFONE1':
        case 'C_DDD2':
        case 'C_TELEFONE2':
        case 'C_DDD3':
        case 'C_TELEFONE3':
        case 'C_DDD_CELULAR1':
        case 'C_CELULAR1':
        case 'C_DDD_CELULAR2':
        case 'C_CELULAR2':
        case 'C_EMAIL':
          return '**********'
        default:
          break;
      }
      return valor;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },
  async mounted() {
    await this.getUser();
    await this.carregaAreas();
    await this.obtemDadosGic();
  },
};
</script>

<style lang="scss" scoped>

.wrapp {
  padding: 16px;
  // max-height: calc(100vh - 72px);
  background-color: white;
  overflow: auto;
}
.pageHeader {
  color: darkgray;
  text-align: center;
  font-size: 26px;
}
.pageFilter {
  background-color: #fdedde;
  color: #f38419;
  display: flex;
  height: 40px;;
}
.pageData {
  color: darkgray;
}
.blwhite {
  border-left: solid white 2px;
  // padding-top: 25px;;
}
ul {
  display: flex;
  padding-left: 0px;
}
li {
  list-style-type: none;
  text-align: center;
}
.inputDate {
  max-width: 200px;
  max-height: 35px;
  margin: 0px 2px;
  padding: 2px;
}
#segmento {
  max-height: 35px;
  padding: 0px 10px;
  width: 100%;
  padding-left: 5px;
}
#areaOper {
  max-height: 35px;
  padding: 0px 10px;
  width: 100%;
  padding-left: 5px;
}
.padlr0 {
  padding-left: 0px;
  padding-right: 0px;
}
.infocard {
  height: 250px;
  border-radius: 10px;
  color: white;
  text-align: center;;
}
.cardicon{
  font-size: 50px;
}
.cardnumber {
  font-size: 24px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.cardtext {
  font-size: 16px;
}
.dflex {
  display: flex;
}
.thcolor {
    background-color: #5576a0;
    color: #fff;
}
.bottom20 {
  padding-bottom: 20px;
}
.wover {
  height: calc(100vh - 72px);
  overflow: auto;
}
#mainpage {
  min-height: 1200px;
}
</style>
<style>
.hidden_header {
  display: none;
}
.txt-fill {
  color: #5576a0;
  font-weight: bold;
}
.max15 {
  width: 15%;
}
.max9 {
  width: 9%;
}
select.custom-select.no-select-caret {
  background-image: none !important;
}
#searchChassi {
  margin: 5px 10px;
  padding: 2px;
  height: 30px;
  width: 300px;
}
.search-chassi-button {
  color: #555;
  background-color: white;
  width:100px;
  height: 30px;
  margin-top: 5px;
  border-style: none;
}
.fullLine {
  width: 100%;
}
#tabchassi thead {
  display: none;
}
#tabchassi td {
  padding: 0px 2px;
}
.tabvalor {
  padding-right: 10px !important;
  width: 20%;
}
.row-realce {
  background: lightcoral;
}
.row-norealce {
  background: lightgray;
}
body {
  overflow: hidden;
}
</style>
